<template>
  <el-col :span="24" id='budgetsImport' class='p-3'>
    <el-row> 
      <el-col :span="22">
        <h2 style="font-weight: 100; display: inline-block;">BUDGET IMPORT</h2>
      </el-col>
      <el-col :span="2"> 
        <el-button class='exit-modal-btn ml-2' type='primary' @click="confirmSave">
          {{ validated && !(this.form.code === this.errorCode) ? 'Import' : 'Validate' }}
        </el-button>
      </el-col>
    </el-row>
    <el-row type='flex' justify='start'>
      <el-col :span="10">
        <el-row justify='start' type='flex'>
          <el-col>
            <HeaderFields
              title=""
              :fields="fields"
              :form="form"
              :idPrefix="'a-'"
              :modalOpen="dialogVisible"
              :isSaving="isSaving"
              ref="HeaderFieldsNew"
              @formChanged="updateForm"
            />
          </el-col>
        </el-row>
        <el-row>
          <div class='row'>
            <div class='col-5' align='right'>
              Upload Budget Files*
            </div>
            <div class='col-7' align='left'>
              <el-button stye='font-size: 13px;' @click='dropzoneVisible = !dropzoneVisible'>
                Select Budget File
              </el-button>
            </div>
          </div>
        </el-row>
        <br>
        <el-row>
          <div>
            {{
                form.files && form.files.length
                  ? this.form.files[0].original_filename
                  : ''
            }}
          </div>
        </el-row>
      </el-col>
      <el-col :span='14' class='p-3 view_file'>
        <span class='header'>View Budget File Status</span>
        <div v-if='errorMessages && errorMessages.length'>
          <table class='table'>
            <thead>
              <tr>
                <th scope='col'>Code</th>
                <th scope='col'>Description</th>
                <th scope='col'>Amount</th>
                <th scope='col'>Error</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for='(error, index) in errorMessages'>
                <td>{{ error.code }}</td>
                <td>{{ error.description }}</td>
                <td align='right'>${{ formatAmountLocale(error.amount) }}</td>
                <td>{{ error.error }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if='displayData && displayData.length'>
          <table class='table'>
            <thead>
              <tr>
                <th scope='col'>Code</th>
                <th scope='col'>Description</th>
                <th scope='col'>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for='(data, index) in displayData'>
                <td>{{ data.code }}</td>
                <td>{{ data.description }}</td>
                <td align='right'>${{ formatAmountLocale(data.amount) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </el-col>
    </el-row>
    <el-dialog id='docs-dialog' title='Import Budgets' size='small' top='10%' :visible.sync='dropzoneVisible'
      :close-on-press-escape='true' :close-on-click-modal='false'>
      <file-import :dz-options='setupImportDropzoneOptions(payload)' @closeImportModal='closeImportModal'
        @onSubmitFiles='onSubmitFiles' @upload-success='dzSuccess' @upload-error='dzFailure'
        @upload-remove='dzRemove' />
    </el-dialog>
  </el-col>
</template>
  
<script>
import { mapGetters } from 'vuex'
import { payload } from '@/components/RouteComponents/Budgets/actionPayload'
import store from '@/store/store'
import NewEntityForm from '@/components/NewEntityForm.vue'
import HeaderInfoText from '@/components/HeaderInfoText'
import { createNewModel } from '@/components/RouteComponents/commonFunctions'
import { systemViewMixins } from '@/Mixins/SystemViewMixins'
import { transactionMixins } from '@/Mixins/Transactions'
import FileImport from '@/components/FileImport.vue'
import HeaderFields from '@/components/HeaderFieldsNew.vue'
import { reportMixins } from '@/Mixins/Reports'
import { formatAmount } from '@/utils/helpers/AmountFormatter'

export default {
  components: {
    NewEntityForm,
    HeaderInfoText,
    FileImport,
    HeaderFields
  },
  mixins: [systemViewMixins, transactionMixins, reportMixins],
  data () {
    return {
      tableHeight: 1000,
      batchUpdateOptions: [{ id: 0, text: 'Delete selected' }],
      batchUpdateSelection: null,
      selection: [],
      dialogFormVisible: false,
      changingPage: false,
      editMode: { active: false, modelId: null },
      dropzoneVisible: false,
      form: {},
      validated: false,
      errorMessages: [],
      displayData: [],
      duplicateCode: false,
      errorCode: null
    }
  },
  methods: {
    formatAmountLocale (value) {
      return formatAmount(value)
    },
    // /**
    //  * Handles paginating between State pages
    //  * @param e  Target page
    //  */
    // changePage (e) {
    //   changePage({ self: this, page: e, payload, query: null, getDeps: true })
    // },
    /**
     * Resets editMode data, resets form to initial state, and displays the
     * modal to create a new model
     */
    createNewModel () {
      createNewModel(this)
    },
    closeImportModal () {
      this.dropzoneVisible = false
    },
    dzSuccess () {
      console.log('file uploaded')
    },
    onSubmitFiles (files) {
      this.form.files = files
      this.dropzoneVisible = false
      this.validated = false
    },
    /**
     * Updates header form
     */
    async updateForm (form, changedField = null) {
      if (changedField === 'code') {
        if (this.duplicateCode && (this.errorCode === form.code)) {
          this.setDuplicateCodeError(true)
        } else if (this.duplicateCode && (this.errorCode !== form.code)) {
          this.setDuplicateCodeError(false)
        }
      }
      this.form = form
      this.validated = false
    },
    async confirmSave () {
      if (this.validateForm() || (this.form.code === this.errorCode)) {
        return
      }

      let formData = new FormData()
      for (const key in this.form) {
        if (key !== 'files') {
          formData.append(`${key}`, this.form[key])
        } else {
          formData.append('file', this.form[key][0].file)
        }
      }
      formData.append('action', (this.validated && !(this.form.code === this.errorCode)) ? 'import' : 'validate')
      formData.append('active', (this.form.active || false))

      try {
        let result = await this.$store.dispatch('importBudget', formData)

        if (result.warnings && result.warnings.length) {
          this.createNotification('Error', `${result.warnings[0]}`, 'warning', null, null, null)
        }
        let offset = 0

        if (result.form_errors && result.form_errors.length) {
          this.duplicateCode = true
          this.errorCode = this.form.code
          this.setDuplicateCodeError(true)
          this.$notify({
            title: 'Error',
            message: `${result.form_errors[0].code}`,
            type: 'error',
            offset
          })
          offset += 100
        } else {
          this.duplicateCode = false
        }

        if (result.data_errors && result.data_errors.length) {
          this.displayData = []
          this.errorMessages = result.data_errors
          this.validated = false
          this.$notify({
            title: 'Error',
            message: 'Failed to validate the budget file',
            type: 'error',
            offset
          })
          offset += 100
        } else if (result.display_data && result.display_data.length) {
          this.errorMessages = []
          this.validated = true
          this.displayData = result.display_data
          if (!result.form_errors.length) {
            this.$notify({
              title: 'Success',
              message: 'File Validation Successful',
              type: 'success',
              offset
            })
            offset += 100
          }
        } else {
          this.validated = false
          this.displayData = []
          this.errorMessages = []
          if (result.status === 'success') {
            this.setForm()
            this.$notify({
              title: 'Success',
              message: result.message,
              type: 'success',
              offset
            })
            offset += 100
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    validateForm () {
      let validationErrors = []
      this.fields.inputFields.forEach(field => {
        if (field.required && (!this.form[field.name] || (this.form[field.name] && (field.fieldType === 'select') && (typeof this.form[field.name] === 'object')) || (field.fieldType === 'input' && !(this.form[field.name] && this.form[field.name].trim() && this.form[field.name].trim().length)))) {
          validationErrors.push(`${field.label} is required field`)
        }
      })
      if (!this.form.files || !this.form.files.length) {
        validationErrors.push(`Budget file is required field`)
      }
      let offset = 0                                                                                  // Set offset so that notifs don't overlap each other
      validationErrors.map(v => {                                                            // Render validation error notifs
        this.$notify({ title: 'Warning', message: v, type: 'warning', offset })
        offset += 100
      })
      return validationErrors.length
    },
    setForm () {
      const form = {
        name: '',
        active: true,
        production: { label: '', value: '' },
        series: { label: '', value: '' },
        set: { label: '', value: '' },
        code: '',
        description: '',
        company: { label: '', value: '' },
        bank: { label: '', value: '' },
        location: { label: '', value: '' },
        files: []
      }
      this.form = form
      this.errorCode = null
      this.duplicateCode = false
    },
    setDuplicateCodeError (fieldError = false) {
      this.$refs['HeaderFieldsNew'].updateFormError(fieldError ? 'code' : null)
    }
  },
  computed: {
    ...mapGetters({
      // banks: 'getAllBanks',
      currencies: 'getAllCurrencies',
      productions: 'getAllProductions',
      companies: 'getAllCompanies',
      series: 'getAllSeries',
      locations: 'getAllLocations',
      sets: 'getAllSets'
    }),
    fields () {
      let fields = {
        inputFields: [
          {
            name: 'name',
            label: 'Name',
            dataType: 'string',
            fieldType: 'input',
            required: true
          },
          {
            name: 'code',
            label: 'Code',
            dataType: 'string',
            fieldType: 'input',
            required: true,
            fieldError: true,
            msg: 'Please provide a description',
            min: 3
          },
          {
            name: 'company',
            label: 'Company',
            type: 'string',
            fieldType: 'select',
            filterable: true,
            required: true,
            options: [
              ...this.companies.map((company) => {
                return { label: company.name, value: company.id }
              })
            ]
          },
          {
            name: 'production',
            label: 'Production',
            type: 'string',
            fieldType: 'select',
            filterable: true,
            required: true,
            options: [
              ...this.productions.map((production) => {
                return { label: production.name, value: production.id }
              })
            ]
          },
          {
            name: 'currency',
            label: 'Currency',
            type: 'string',
            fieldType: 'select',
            filterable: true,
            required: true,
            options: [
              ...this.currencies.map((currencies) => {
                return { label: currencies.code, value: currencies.id }
              })
            ]
          },
          {
            name: 'series',
            label: 'Series',
            type: 'string',
            fieldType: 'select',
            filterable: true,
            required: true,
            options: [
              ...this.series.map((series) => {
                return { label: series.name, value: series.id }
              })
            ]
          },
          {
            name: 'location',
            label: 'Location',
            type: 'string',
            fieldType: 'select',
            filterable: true,
            required: true,
            options: [
              ...this.locations.map((location) => {
                return { label: location.name, value: location.id }
              })
            ]
          },
          {
            name: 'set',
            label: 'Set',
            type: 'string',
            fieldType: 'select',
            filterable: true,
            required: true,
            options: [
              ...this.sets.map((set) => {
                return { label: set.name, value: set.id }
              })
            ]
          },
          {
            name: 'active',
            label: 'Active',
            dataType: 'boolean',
            fieldType: 'checkbox'
          }
        ]
      }
      return fields
    }
  },
  /**
   * Pre-route enter logic.
   * @param to
   * @param from
   * @param next
   */
  beforeRouteEnter (to, from, next) {
    // let clearCache = !['banks', 'productions', 'companies'].includes(payload.endpoint)
    let initPromises = [
      store.dispatch('clearLocalState', {
        clearMutation: payload.clearMutation,
        clearCache: true
      })
    ]
    const fieldsAlreadyExist =
      !typeof store.getters.getResourceFieldsByEndpoint(payload.endpoint) ===
      'undefined'
    if (!fieldsAlreadyExist) {
      initPromises.push(store.dispatch('fetchOptions', payload))
    }
    Promise.all(initPromises)
      .then(() => store.dispatch('fetch', payload))
      .then((entities) => store.dispatch('findDependencies', entities))
      .then((promises) => Promise.all(promises))
      .then(() => next())
      .catch((e) => console.log(e))
  },
  created () {
    this.endpoint = payload.endpoint
    this.moduleName = payload.moduleName
    this.payload = payload
    this.generateForm()
    this.setForm()
  },
  mounted () {
    this.$nextTick = () => {
      const tableHeight = () => {
        const parentHeight = document.getElementById('budgets').offsetHeight
        const headerHeight =
          document.getElementById('budgets-header').offsetHeight
        return parentHeight - headerHeight
      }
      this.tableHeight = tableHeight()
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('isEditingForm', false)
    this.$store
      .dispatch('clearFilters')
      .then(() => next())
      .catch((e) => {
        console.log(e)
        next()
      })
  }
}
</script>
  
<style scoped>
#budgets-header {
  border-bottom: 1px solid lightgray;
}

.h-padded {
  padding: 0 12px;
}

.right-aligned-col {
  text-align: right;
}

.el-table .modified-row {
  background: #c9e5f5;
}

.view_file {
  min-height: 600px;
  max-height: 600px;
  border: 1px solid #ccc;
  margin: 20px;
  overflow-y: scroll;
}

.header {
  background: #e2f0f5;
  display: block;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

td .el-select {
  display: block !important;
}
</style>
<style>
#budgetsImport td .el-select {
  width: 100% !important;
}
</style>
  


// WEBPACK FOOTER //
// src/components/RouteComponents/Budgets/BudgetImport.vue